<template>
  <div class="xes-lotterySquare">
    <div
      ref="lotteryAward"
      class="xes-lotterySquare-circle"
      v-if="config.model === 'circle'"
      :style="{ background: config.background || '#73AAF0' }"
    >
      <template v-for="(item, index) in awardLists">
        <div
          v-if="index === 4"
          class="xes-lotterySquare-award"
          :key="item.id"
          @click="startDraw"
        >
          <van-loading size="24px" vertical v-if="isloading"></van-loading>
          <div class="img" v-if="item.picture && !isloading">
            <img :src="item.picture" class="pic">
          </div>
          <span class="poptip" v-if=" drawNum > 0">剩{{drawNum}}次机会</span>
          <span class="tips" v-if="drawNum === 0 && showTips"></span>
        </div>
        <div v-else class="xes-lotterySquare-award" :key="item.id">
          <div
            class="xes-lotterySquare-text"
            :class="{
              active: curGameIdx == index && bgIsColor,
              activeImg: curGameIdx == index && !bgIsColor
            }"
            :style="getAwardBackground(item)"
          >
            <div class="list" v-if="item.picture">
              <img :src="item.picture" alt="" class="img">
              <p class="name">{{item.name}}</p>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div ref="lotteryAward" v-else class="xes-lotterySquare-awardList">
      <template v-for="(item, index) in awardLists">
        <div
          v-if="index == 4"
          class="xes-lotterySquare-award"
          :class="{ active: curGameIdx == index }"
          :key="item.id"
          @click="startDraw"
        >
          <img :src="item.picture" />
        </div>
        <div
          v-else
          class="xes-lotterySquare-award"
          :class="{ active: curGameIdx == index }"
          :style="getAwardBackground(item)"
          :key="item.id"
        >
          <div v-if="item.description && item.description.list" class="xes-lotterySquare-text">
            <p v-for="(text, index) in item.description.list" :key="index">{{ text }}</p>
          </div>
        </div>
      </template>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'xes-lottery-square',
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    },
    awardList: {
      type: Array,
      default: () => {
        return []
      }
    },
    awardIndex: {
      type: [Number, String],
      default: 0
    },
    isStart: {
      type: Boolean,
      default: false
    },
    drawNum: {
      type: [Number, String],
      default: 0
    },
    isloading: {
      type: Boolean,
      default: true
    },
    showTips: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      oil: true, // 默认加速
      total: 8, // 奖品总数
      speed: 400, // 动画速度
      max_speed: 100, // 最大速度时间间隔
      min_speed: 500, // 最小速度时间间隔
      isFinish: false, // 是否旋转完成
      endIdx: 0, // 上一次的旋转结束索引值
      curGameIdx: -1, // 当前选中态所在下标
      idx: 0, // 当前所在下标
      isTurning: false, // 是否正在旋转
      orderList: [0, 1, 2, 5, 8, 7, 6, 3], // index转圈矫正
      bgIsColor: false // 背景为颜色
    }
  },
  computed: {
    awardLists() {
      const _awardList = this.awardList.concat([])
      _awardList.splice(4, 0, { id: -1, picture: this.config.pointerImage })
      return _awardList
    }
  },
  watch: {
    isStart(newValue) {
      if (newValue) {
        this.start()
      }
    }
  },
  methods: {
    // 开始按钮点击
    startDraw() {
      this.$emit('startDraw')
    },
    // 开始抽奖
    start(awardIndex, cb) {
      if (this.isTurning) {
        return
      }

      if (awardIndex) {
        this.awardIndex = awardIndex
      }

      this.run(cb)
      setTimeout(() => {
        this.oil = false
      }, 3000)
    },
    // 抽奖运行过程
    run(cb) {
      this.idx = ++this.idx % this.total
      this.curGameIdx = this.orderList[this.idx]
      this.isTurning = true
      this.speedControl() // 速度变化

      if (!this.isFinish) {
        setTimeout(() => {
          this.run()
        }, this.speed)
      } else {
        this.isTurning = false
        this.oil = true
        this.speed = 400
        this.isFinish = false
        typeof cb === 'function' && cb()
        this.$emit('onComplete')
        console.log('抽奖完成')
      }
    },
    // 速度控制
    speedControl() {
      // 初始加速
      if (this.speed > this.max_speed) {
        if (this.oil) {
          this.speed -= 60
        }
      }
      // 结束减速
      if (!this.oil) {
        if (this.speed < this.min_speed) {
          this.speed += 200
        } else if (+this.awardIndex === this.idx) {
          this.isFinish = true
        }
      }
    },
    getAwardBackground(item) {
      const style = {}
      // 背景样式
      const background = item.background || item.picture
      if (background) {
        const reg = /^[#].{6}$/
        const isColor = reg.test(background)
        this.bgIsColor = isColor
        style.background = isColor ? background : `url(${background})`
      }
      // 描述文案样式
      if (item.description) {
        const { position: pos, color } = item.description
        style.alignItems = pos !== 'center' ? `flex-${pos}` : 'center'
        style.color = color
      }
      return style
    }
  }
}
</script>
<style lang="less" scoped>
.xes-lotterySquare {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  &-circle {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    height: 100%;
    padding: 12px/2;
    overflow: hidden;
    border-radius: 15px;

    .xes-lotterySquare-award {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 33.33%;
      height: 33.33%;
      // padding: 5px;
      background-size: 100% 100% !important;
      border-radius: 5px;

      .img {
        width: 100%;
        overflow: hidden;
        border-radius: 5px;

        img {
          width: 100%;
        }
      }

      .poptip {
        position: absolute;
        top: -3px;
        left: 50%;
        z-index: 2;
        width: 134px/2;
        height: 43px/2;
        font-size: 20px/2;
        font-weight: normal;
        font-family: FZLTZHUNHK;
        line-height: 47px/2;
        text-align: center;
        color: #532600;
        background: url(./images/poptip.png) no-repeat;
        background-size: cover;
      }

      .tips {
        position: absolute;
        top: -3px;
        left: 50%;
        z-index: 2;
        width: 157px/2;
        height: 43px/2;
        background: url(./images/tips.png) no-repeat;
        background-size: cover;
      }
    }

    .xes-lotterySquare-text {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      padding: 8px 0;
      font-size: 15px;
      font-weight: 400;
      text-align: center;
      background: white;
      background-size: 100% 100% !important;
      border-radius: 5px;

      .list {
        width: 100%;
      }

      .img {
        width: 100px/2;
        height: 100px/2;
      }

      .name {
        width: 100%;
        padding: 0 8px;
        margin-top: 3px;
        overflow: hidden;
        font-size: 10px;
        white-space: nowrap;
        color: #9a581e;
        text-overflow: ellipsis;
      }

      &.active {
        background: rgba(235, 76, 78, 1) !important;
      }

      &.activeImg {
        position: relative;
        background-image: url(https://editor.xesimg.com/tailor/resource/lottery-active-1622105385906.png) !important;
      }
    }
  }

  &-awardList {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    height: 100%;

    .xes-lotterySquare-award {
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      width: 33%;
      height: 33%;
      background-size: 100% 100% !important;

      &.active {
        position: relative;
        border: 1px solid red;

        &::before {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background-color: rgba(255, 0, 0, 0.6);
          content: '';
        }
      }

      img {
        width: 100%;
      }
    }

    .xes-lotterySquare-text {
      margin: 8px;
    }
  }

  .loading {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  // &-pointer {
  //   position: absolute;
  //   left: 50%;
  //   top: 50%;
  //   width: 33%;
  //   height: 33%;
  //   transform: translate(-50%, -50%);
  // }
}
</style>
